import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { deleteMultipleQuestionAnswerAction } from '../../redux/toolkit/question-answer/deleteMultipleQna'
import { getAllQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAllQuestionAnswer'
import PropTypes from 'prop-types';
var res;

export default function DeleteMulQnA({ qns_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const delCat = useSelector(state => state.deleteQuestionAnswer)
    const { status, message } = delCat
    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)

    }

    const delCatHandle = async () => {
         res=await dispatch(deleteMultipleQuestionAnswerAction({qns_id:qns_id,is_delete:true}))
        await dispatch(getAllQuestionAnswerAction({ is_deleted: false }))
        setSnack(true)
        setState(false)
    }




    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={res?.payload?.message} />
        </>

    )
}



DeleteMulQnA.propTypes = {
    qns_id: PropTypes.arrayOf(PropTypes.string),
    state: PropTypes.any,
    setState: PropTypes.any
  };